
import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/mrk/${ view }.vue`);
}

const Index = loadView( 'Index' );

const mrkRoutes = [
    {
        path: 'mrk',
        name: 'api.mrk.resource.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'mrk/:id',
        name: 'api.mrk.resource.get',
        component: Index,
        meta: {
            middleware: permission
        }
    },
];

export default mrkRoutes;
